import React from "react";
import {
  Checkbox,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SelectCustom from "../../Generics/Select";

const CompanyItaComponent = ({
  onChange,
  practice,
  errors,
  tooltipContent,
  handleModalClick,
  ruolo,
}) => {
  const handleInputChange = (field, event) => {
    const { value } = event.target;
    onChange(field, value);
  };

  return (
    <>
      {practice?.cliente?.status === "Già cliente LEXIA" ? (
        <>
          {/* Denominazione sociale */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Denominazione sociale
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.denominazione_sociale}
              error={errors.includes("denominazione_sociale")}
              onChange={(e) => handleInputChange("denominazione_sociale", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
        </>
      ) : (
        <>
          {" "}
          {/* Denominazione sociale */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Denominazione sociale
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.denominazione_sociale}
              error={errors.includes("denominazione_sociale")}
              onChange={(e) => handleInputChange("denominazione_sociale", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* P.I. o CODICE FISCALE */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Partiva IVA o Codice fiscale (facoltativo)
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.partita_iva}
              error={errors.includes("partita_iva")}
              onChange={(e) => handleInputChange("partita_iva", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Comune */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Comune
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.comune}
              error={errors.includes("comune")}
              onChange={(e) => handleInputChange("comune", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Indirizzo/ num civico */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Indirizzo e Civico
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.indirizzo}
              error={errors.includes("indirizzo")}
              onChange={(e) => handleInputChange("indirizzo", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* CAP */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                CAP (facoltativo)
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              variant="outlined"
              value={practice?.cliente?.CAP}
              error={errors.includes("CAP")}
              onChange={(e) => handleInputChange("CAP", e)}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Codice SDI o PEC */}
          <Grid item xs={11} md={4}>
            <div
              style={{
                display: "flex",
                height: "20px",
              }}
            >
              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px" }}
              >
                Codice SDI o PEC (facoltativo)
              </Typography>
            </div>

            <TextField
              style={{ marginTop: "10px" }}
              placeholder="Inserisci"
              value={practice?.cliente?.SDI}
              error={errors.includes("SDI")}
              onChange={(e) => handleInputChange("SDI", e)}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #1b2838",
                  },
                },
              }}
              InputProps={{
                style: {
                  color: "#1b2838",
                },
              }}
            />
          </Grid>
          {/* Appartenenza Cliente */}
          <Grid
            item
            xs={11}
            md={4}
            sx={
              {
                // mt: {
                //   xs: 0,
                //   md:
                //     practice?.cliente?.appartiene_gruppo_societario === "Sì"
                //       ? "30px"
                //       : 0,
                // },
              }
            }
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                borderRadius: "0px",
                // padding: "15px 14px",
                padding: 0,
              }}
            >
              <Checkbox
                sx={{
                  transform: "scale(1.1)",
                  padding: 0,
                  marginRight: "10px",
                  color: "#929292ff",
                  "&.Mui-checked": {
                    color: "#afaeaeff",
                  },
                }}
                inputProps={{ style: { margin: 0, padding: 0 } }}
                checked={
                  practice?.cliente?.appartiene_gruppo_societario === "Sì"
                }
                error={errors.includes("appartiene_gruppo_societario")}
                onChange={(e) =>
                  handleInputChange("appartiene_gruppo_societario", {
                    target: { value: e.target.checked ? "Sì" : "" },
                  })
                }
              />

              <Typography
                className="color-blue-dark"
                style={{ fontSize: "14px", marginTop: "2px" }}
              >
                Il cliente appartiene a un gruppo societario?
              </Typography>

              <div
                className="icon-modal-info"
                style={{ marginLeft: "10px", cursor: "pointer" }}
                onClick={() =>
                  handleModalClick(tooltipContent.appartiene_gruppo_societario)
                }
              />
            </div>
          </Grid>
          <Grid item xs={11} md={4} style={{ padding: 0 }}></Grid>
          <Grid item xs={11} md={4} style={{ padding: 0 }}></Grid>
          {practice?.cliente?.appartiene_gruppo_societario === "Sì" ? (
            <>
              {" "}
              {/* Denominazione del gruppo  */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Denominazione del gruppo/holding
                  </Typography>
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  placeholder="Inserisci"
                  variant="outlined"
                  value={practice?.cliente?.denominazione_gruppo_holding}
                  error={errors.includes("denominazione_gruppo_holding")}
                  onChange={(e) =>
                    handleInputChange("denominazione_gruppo_holding", e)
                  }
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>
              {/* Capogruppo */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Capogruppo (società controllante)
                  </Typography>
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  placeholder="Inserisci"
                  variant="outlined"
                  value={practice?.cliente?.capogruppo}
                  error={errors.includes("capogruppo")}
                  onChange={(e) => handleInputChange("capogruppo", e)}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>
              {/* relazione_cliente_gruppo */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Ruolo/relazione del cliente nel gruppo
                  </Typography>
                </div>

                <Select
                  value={practice?.cliente?.relazione_cliente_gruppo || ""}
                  error={errors.includes("relazione_cliente_gruppo")}
                  onChange={(e) =>
                    handleInputChange("relazione_cliente_gruppo", {
                      target: { value: e.target.value },
                    })
                  }
                  displayEmpty
                  fullWidth
                  style={{ marginTop: "10px" }}
                >
                  <MenuItem value="">
                    <span style={{ color: "#abb0b6" }}>Seleziona</span>
                  </MenuItem>
                  {ruolo.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item}
                      style={{ color: "#1b2838" }}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              {/* Società del gruppo rilevanti ai fini del mandato */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Società del gruppo rilevanti ai fini del mandato
                    (facoltativo)
                  </Typography>
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  multiline
                  rows={5}
                  placeholder="Inserisci"
                  variant="outlined"
                  value={practice?.cliente?.gruppo_societa_rilevante}
                  error={errors.includes("gruppo_societa_rilevante")}
                  onChange={(e) =>
                    handleInputChange("gruppo_societa_rilevante", e)
                  }
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>
              {/* Altro */}
              <Grid item xs={11} md={4}>
                <div
                  style={{
                    display: "flex",
                    height: "20px",
                  }}
                >
                  <Typography
                    className="color-blue-dark"
                    style={{ fontSize: "14px" }}
                  >
                    Altro (facoltativo)
                  </Typography>
                </div>

                <TextField
                  style={{ marginTop: "10px" }}
                  multiline
                  rows={5}
                  placeholder="Controparti o soggetti co-interessati o contro-interessati rispetto alle attività rientranti nell’incarico"
                  variant="outlined"
                  value={practice?.cliente?.altre_controparti}
                  error={errors.includes("altre_controparti")}
                  onChange={(e) => handleInputChange("altre_controparti", e)}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #1b2838",
                      },
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#1b2838",
                    },
                  }}
                />
              </Grid>
            </>
          ) : null}
        </>
      )}
    </>
  );
};

export default CompanyItaComponent;
